export default __webpack_public_path__ + "static/media/Guru-Parampara-13.250efcfe.png";